import { OrderResponseStatus } from "src/contexts/documentationArea/domain/OrderResponseStatus";
import { OrderTypes } from "src/contexts/documentationArea/domain/OrderTypes";

const RESPONSE_STATUS_MESSAGE_KEYS: Record<OrderResponseStatus, string> = {
  [OrderResponseStatus.VALID]: "documentation_area.order_box.response_item.status.valid",
  [OrderResponseStatus.INVALID]: "documentation_area.order_box.response_item.status.invalid",
  [OrderResponseStatus.PENDING_REVIEW]: "documentation_area.order_box.response_item.status.pending",
};

export const getResponseStatusMessageKey = (
  orderType: OrderTypes,
  responseStatus: OrderResponseStatus,
) => {
  if (orderType === OrderTypes.OTHER_DOCUMENT && responseStatus === OrderResponseStatus.VALID) {
    return "documentation_area.order_box.response_item.status.shared_document_valid";
  }

  return RESPONSE_STATUS_MESSAGE_KEYS[responseStatus];
};
